export default __webpack_public_path__ + "static/media/Medium's Robe of the Dark Pact.bc568186.jpg";